import HistoryPredictions from 'components/HistoryPredictions';
import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import navHistoryIcon from '../../assets/images/header/figma-header-1.png';
import navPredictIcon from '../../assets/images/header/figma-header-2.png';
import navResultIcon from '../../assets/images/header/figma-header-5.png';
import navRulesIcon from '../../assets/images/header/figma-header-6.png';
import homeIcon from '../../assets/images/header/home.svg';
import { getAllSetting } from '../../service/base';
import { CONST_SITE } from '../../utils/common/const';

const navItems = [
  {
    name: 'Dự đoán',
    href: '/',
    icon: navPredictIcon,
    isActive: (pathname) => pathname === '/'
  },
  {
    name: 'Thể lệ',
    href: '/rule',
    icon: navRulesIcon,
    isActive: (pathname) => pathname === '/rule'
  },
  {
    name: 'Kết quả',
    href: '/prize-structure',
    icon: navResultIcon,
    isActive: (pathname) => pathname === '/prize-structure'
  },
  {
    name: 'Lịch sử',
    icon: navHistoryIcon,
    onClick: 'history'
  }
];

const HeaderBar = () => {
  const [settings, setSettings] = useState({
    link_login: '#',
    link_register: '#',
    link_home: '#'
  });
  const location = useLocation();
  const mounted = useRef(false);
  const [isShowMenu, setIsShowMenu] = useState(false);
  const [isModalHistory, setIsModalHistory] = useState(false);
  const [IP, setIP] = useState('');
  const [FP, setFP] = useState('');

  useEffect(() => {
    setIsShowMenu(false);
  }, [location.pathname]);

  useEffect(() => {
    mounted.current = true;

    const fetchData = async () => {
      try {
        const res = await getAllSetting({
          site: CONST_SITE.CM88
        });
        if (mounted.current) {
          const settingsMap = {};
          res.data.forEach((item) => {
            settingsMap[item.key] = item.content || '#';
          });
          setSettings(settingsMap);
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };

    fetchData();

    return () => {
      mounted.current = false;
    };
  }, []);

  const closeMenu = () => setIsShowMenu(false);

  const handleHistoryClick = () => {
    closeMenu();
    setIsModalHistory(true);
  };

  return (
    <nav className="relative z-50 shrink-0">
      <div className="relative h-[56px] bg-white backdrop-blur-[2px]">
          <div className="mx-auto grid h-full grid-cols-[22px_1fr_22px] items-center px-[35px]">
            <a
              href={settings.link_home}
              target="_blank"
              rel="noopener noreferrer"
              className="flex size-[22px] items-center justify-center justify-self-start"
              aria-label="Về trang chủ"
            >
              <img
                src={homeIcon}
                alt=""
                width={22}
                height={22}
                className="size-[22px]"
                aria-hidden="true"
              />
            </a>
            <img
              src="/assets/images/header/cm88.png"
              alt="CM88"
              width={100}
              height={26}
              className="h-[26px] w-[100px] justify-self-center object-contain"
            />
            <button
              type="button"
              onClick={() => setIsShowMenu((open) => !open)}
              className="flex size-[22px] flex-col items-center justify-center gap-[3px] justify-self-end border-0 bg-transparent p-0 outline-none"
              aria-controls="mobile-navbar-cta"
              aria-expanded={isShowMenu}
            >
              <span className="sr-only">Mở menu</span>
              <span className="h-[5px] w-full rounded-[2.5px] bg-[#36A638]" />
              <span className="h-[5px] w-full rounded-[2.5px] bg-[#36A638]" />
              <span className="h-[5px] w-full rounded-[2.5px] bg-[#36A638]" />
            </button>
          </div>

          {isShowMenu && (
            <div id="mobile-navbar-cta" className="absolute inset-x-0 top-full z-50 px-[23px] pt-2">
              <div className="rounded-[12px] bg-white p-[9px] shadow-[0_12px_32px_rgba(0,0,0,0.16)]">
                <div className="mb-5 flex gap-[7px]">
                  <a
                    href={settings.link_login}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={closeMenu}
                    className="inline-flex h-[44px] flex-1 items-center justify-center rounded-[8px] bg-[#36A638] px-2 text-[18px] font-medium text-white"
                  >
                    Đăng nhập
                  </a>
                  <a
                    href={settings.link_register}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={closeMenu}
                    className="inline-flex h-[44px] flex-1 items-center justify-center rounded-[8px] border border-solid border-[#36A638] bg-white px-2 text-[18px] font-medium text-[#36A638]"
                  >
                    Đăng ký
                  </a>
                </div>
                <ul className="flex flex-col gap-7">
                  {navItems.map((item) => {
                    const isActive = item.isActive ? item.isActive(location.pathname) : false;
                    const icon = (
                      <span className="flex h-[26px] w-[26px] shrink-0 items-center justify-center overflow-hidden">
                        <img
                          src={item.icon}
                          alt=""
                          width={26}
                          height={26}
                          className="h-full w-full object-contain"
                          aria-hidden="true"
                        />
                      </span>
                    );

                    if (item.onClick === 'history') {
                      return (
                        <li key={item.name}>
                          <button
                            type="button"
                            onClick={handleHistoryClick}
                            className="flex w-fit items-center gap-[10px] border-0 bg-transparent p-0 text-[15px] font-medium leading-none text-[#363636] outline-none"
                          >
                            {icon}
                            <span className="leading-none">{item.name}</span>
                          </button>
                        </li>
                      );
                    }

                    return (
                      <li key={item.href}>
                        <Link
                          to={item.href}
                          onClick={closeMenu}
                          className={`flex w-fit items-center gap-[10px] text-[15px] font-medium leading-none ${
                            isActive ? 'text-[#36A638]' : 'text-[#363636]'
                          }`}
                        >
                          {icon}
                          <span
                            className={
                              isActive ? 'border-b border-[#36A638] pb-1 leading-none' : 'leading-none'
                            }
                          >
                            {item.name}
                          </span>
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          )}
        </div>

      <HistoryPredictions
        isModalVote={isModalHistory}
        setIsModalVote={setIsModalHistory}
        IP={IP}
        FP={FP}
      />
    </nav>
  );
};

const HeaderMenu = () => {
  return (
    <div className="mx-auto flex w-full items-center justify-center pb-3 pt-2">
      <img
        src="/assets/images/header/bannermb.png"
        alt=""
        className="flex h-auto w-[80%] object-contain"
      />
    </div>
  );
};

export { HeaderBar };
export default HeaderMenu;
